import OurStory from '../containers/our-story';

export default OurStory;
